// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class CollaboratorDetails {
  roleId: number;
  role: string;
  name: string;
  email: string;
  canEdit: boolean;
  isPrimaryUser: boolean;
}
